import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Block, BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-one-page-new',
    templateUrl: './one-page-new.component.html',
    styleUrls: ['./one-page-new.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class OnePageNewComponent extends BlockAbstractComponent implements OnInit {

    public panelStates!: boolean[];

    override ngOnInit() {
        super.ngOnInit();
        this.panelStates = new Array((this.block.content ?? []).length).fill(false);
        this.block.content = (this.block.content ?? []).map((block: Block) => {
            if (block.data?.isAnchor && !block.data.anchorId) {
                block.data.anchorId = (block.data.title ?? '').toLowerCase()
                    .replace(/\s+/g, '-')         // Replace spaces with -
                    .replace(/[^a-z0-9-]/g, '')   // Remove all non-word chars except hyphens
                    .replace(/-+/g, '-');         // Replace multiple - with single -
            }
            return block;
        })
    }

    setState(i: number, state: boolean): void {
        this.panelStates[i] = state;
    }

    getPanelState(i: number): string {
        return this.panelStates[i] ? 'expand' : 'collapse';
    }

}
